import { useCallback, useEffect, useState } from 'react';
import { DeliveryQueueJobSummary, deliveryQueueService } from '../services/firebaseFunctions';

export function useDeliveryQueueJobs() {
  const [jobs, setJobs] = useState<DeliveryQueueJobSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [cancellingJobId, setCancellingJobId] = useState<string | null>(null);
  const [cancelError, setCancelError] = useState<string | null>(null);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await deliveryQueueService.listProcessingJobs();
      setJobs([...data].sort((a, b) => b.createdAt.localeCompare(a.createdAt)));
    } catch {
      setError('Erro ao carregar jobs em andamento');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const cancelJob = useCallback(async (jobId: string, reason?: string) => {
    setCancellingJobId(jobId);
    setCancelError(null);
    try {
      await deliveryQueueService.cancelJob(jobId, reason);
      await load();
    } catch (caught) {
      setCancelError(caught instanceof Error ? caught.message : 'Erro ao cancelar job');
    } finally {
      setCancellingJobId(null);
    }
  }, [load]);

  return {
    jobs,
    loading,
    error,
    cancelJob,
    cancellingJobId,
    cancelError,
    reload: load,
  };
}
